import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import './MuiTable.css'
import React from 'react';
  
const MuiTable = ({tableData}) => {
    const hasData = tableData.length > 0
    const headers = hasData ? Object.keys(tableData[0]) : [];
    return (
      <div className='tableCard'>
        <Paper>
            <TableContainer sx={{ maxHeight: '360px'}}>
                <Table aria-label='simple table' stickyHeader>
                    <TableHead>
                        <TableRow>
                            {headers.map((header) => (
                                    <TableCell key={header}>{header}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            hasData && tableData.map((row, rowIndex) => (
                                <TableRow
                                    key={rowIndex}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    {headers.map((header) => (
                                        <TableCell key={header}>{row[header]}</TableCell>
                                    ))}
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
      </div>
    )
}
export default MuiTable;